import { takeEvery,  put,  call } from "redux-saga/effects"

// new Password Redux States
import { GET_CAREER_INFO,EDIT_CAREER_INFO, GET_CAREER_PAGE, EDIT_CAREER_PAGE, GET_CAREER_DEFAULT } from "./actionTypes"
import { getCareerInfoSuccess,getCareerInfoFailure ,editCareerInfoSuccess,editCareerInfoFailure,getCareerPageSuccess,getCareerPageFailure,editCareerPageSuccess,editCareerPageFailure, getCareerPageDefaultSuccess, getCareerPageDefaultFailure} from "./actions"
//Include Both Helper File with needed methods
import { getCareerInfo,editCareerInfo, putCall} from "../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../common/constant/constantURL"

function* handleGetCareerInfo(id) {
try{ 
    const clientId=id.payload;

     
     const url=constClass.REST_API_GET_CAREER_INFO+clientId
     const response = yield call(getCareerInfo,url)
     yield put(getCareerInfoSuccess(response))
}catch (error) {
    yield put(getCareerInfoFailure(error))
  }

}

function* handleGetCareerPage() {
    try{  
         const url=constClass.REST_API_GET_CAREER_PAGE
         const response = yield call(getCareerInfo,url)
        
         yield put(getCareerPageSuccess(response))
    }
    catch (error) 
    {
        yield put(getCareerPageFailure(error))
      }
    
    }

function* handleEditCareerInfo({payload:{obj,id}}){
    try{
        
       
        const url=constClass.REST_API_EDIT_CAREER_INFO+id
        
        const response = yield call(editCareerInfo,url,obj)



        yield put(editCareerInfoSuccess(response.message))
        
    }
    catch(error){
        yield put(editCareerInfoFailure(error))
        

    }
}

function* handleEditCareerPage(obj){
    try{
        
       
        const url=constClass.REST_API_GET_CAREER_PAGE
        
        const response = yield call(putCall,url,obj.payload)



        yield put(editCareerPageSuccess(response))
        
    }
    catch(error){
        yield put(editCareerPageFailure(error))
        

    }
}

function* handleDefaultCareerPage(){
    try{  
        const url=constClass.REST_API_GET_CAREER_PAGE_DEFAULT
        const response = yield call(getCareerInfo,url)
        
       
        yield put(getCareerPageDefaultSuccess(response))
   }
   catch (error) 
   {
       yield put(getCareerPageDefaultFailure(error))
     }
   
}


function* careerInfoSaga() {
    yield takeEvery(GET_CAREER_INFO, handleGetCareerInfo)
    yield takeEvery(EDIT_CAREER_INFO, handleEditCareerInfo)
    yield takeEvery(GET_CAREER_PAGE,handleGetCareerPage)
    yield takeEvery(EDIT_CAREER_PAGE,handleEditCareerPage)
    yield takeEvery(GET_CAREER_DEFAULT,handleDefaultCareerPage)
   
  }


  export default careerInfoSaga